var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4689 9.1665H23.4822M9.46891 3.1665H22.8022C26.4841 3.1665 29.4689 6.15127 29.4689 9.83317V23.1665C29.4689 26.8484 26.4841 29.8332 22.8022 29.8332H9.46891C5.78701 29.8332 2.80225 26.8484 2.80225 23.1665V9.83317C2.80225 6.15127 5.78701 3.1665 9.46891 3.1665ZM21.4689 15.6598C21.6335 16.7695 21.4439 17.9028 20.9273 18.8985C20.4106 19.8943 19.5931 20.7017 18.5911 21.2061C17.5891 21.7104 16.4535 21.886 15.346 21.7077C14.2384 21.5295 13.2153 21.0066 12.422 20.2134C11.6288 19.4202 11.1059 18.397 10.9277 17.2895C10.7495 16.1819 10.925 15.0464 11.4293 14.0443C11.9337 13.0423 12.7412 12.2248 13.7369 11.7082C14.7326 11.1915 15.8659 11.002 16.9756 11.1665C18.1075 11.3344 19.1554 11.8618 19.9645 12.6709C20.7736 13.48 21.3011 14.5279 21.4689 15.6598Z",
    stroke: "currentColor",
    strokeWidth: 2.74576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7c950e399018063455c079dde041873f.svg";
export { ForwardRef as ReactComponent };